'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _List = require('./List');

var _List2 = _interopRequireDefault(_List);

var _Form = require('./Form');

var _Form2 = _interopRequireDefault(_Form);

var _componentsTabbablePage = require('../../components/TabbablePage');

var _componentsTabbablePage2 = _interopRequireDefault(_componentsTabbablePage);

var _reactDocumentTitle = require('react-document-title');

var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);

var _components = {
	_$Page: {
		displayName: 'Page'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Page = (function (_React$Component) {
	_inherits(Page, _React$Component);

	function Page() {
		_classCallCheck(this, _Page);

		_React$Component.apply(this, arguments);
	}

	Page.prototype.render = function render() {
		return _react2['default'].createElement(
			_reactDocumentTitle2['default'],
			{ title: 'Klienti' },
			_react2['default'].createElement(_componentsTabbablePage2['default'], _extends({
				module: 'client',
				List: _List2['default'],
				Form: _Form2['default'],
				newTitle: 'Nový',
				listTitle: 'Seznam klientů'
			}, this.props))
		);
	};

	var _Page = Page;
	Page = _wrapComponent('_$Page')(Page) || Page;
	return Page;
})(_react2['default'].Component);

exports['default'] = Page;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Client/Page.js
 ** module id = 981
 ** module chunks = 2
 **/